const getActions = (dispatch)=>{
    const updatePurchaseType = (purchaseType)=>{
        dispatch({
            type: 'setPurchaseType',
            payload: {
                purchaseType
            }
        });
        dispatch({
            type: 'updateAllValidations'
        });
        dispatch({
            type: 'resetErrors'
        });
    };
    const updateDeliveryInterval = (deliveryInterval)=>{
        dispatch({
            type: 'setDeliveryInterval',
            payload: {
                deliveryInterval
            }
        });
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const triggerValidationErrors = ()=>{
        dispatch({
            type: 'updateAllValidations'
        });
        dispatch({
            type: 'triggerErrors'
        });
    };
    return {
        updatePurchaseType,
        updateDeliveryInterval,
        triggerValidationErrors
    };
};

export { getActions };
//# sourceMappingURL=actions.js.map
